import { useEffect, useState } from 'react';

export interface CountdownTimeLeft {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
}

/**
 * Returns a live countdown to `targetDate`, updating every second.
 * Returns `null` when `targetDate` is null or when the deadline has passed.
 */
export function useCountdown(targetDate: string | null): CountdownTimeLeft | null {
    const [timeLeft, setTimeLeft] = useState<CountdownTimeLeft | null>(null);

    useEffect(() => {
        if (!targetDate) {
            setTimeLeft(null);
            return;
        }
        const target = new Date(targetDate).getTime();
        const tick = () => {
            const diff = target - Date.now();
            if (diff <= 0) {
                setTimeLeft(null);
                return;
            }
            setTimeLeft({
                days: Math.floor(diff / 86_400_000),
                hours: Math.floor((diff % 86_400_000) / 3_600_000),
                minutes: Math.floor((diff % 3_600_000) / 60_000),
                seconds: Math.floor((diff % 60_000) / 1_000),
            });
        };
        tick();
        const id = setInterval(tick, 1000);
        return () => clearInterval(id);
    }, [targetDate]);

    return timeLeft;
}
